import React from 'react'

export const GroupCardSkeleton = (): React.ReactElement => {
  return (
    <div className="bg-dark-gray rounded-lg overflow-hidden animate-pulse">
      <div className="aspect-video bg-gray-700"></div>
      <div className="p-4">
        <div className="h-6 bg-gray-700 rounded mb-2 w-3/4"></div>
        <div className="h-4 bg-gray-700 rounded mb-3 w-full"></div>
        <div className="h-4 bg-gray-700 rounded w-1/2"></div>
      </div>
    </div>
  )
}
